import React, { useState, useEffect, useRef } from "react";
import './Header.css';
import { Link } from 'react-router-dom';
import logoBarra from '../../Images/logoBarra.png';
import logobrilhopequeno from '../../Images/logopequenobrilho.png';
import logoPT from '../../Images/logoPT.png';
import logoEN from '../../Images/logoEN.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const HeaderApp = ({onHeaderClick}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [language, setLanguage] = useState('pt');
  const [menuItemOpen, setMenuItem] = useState(2);
  const [isExperiencesOpen, setIsExperiencesOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {    
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    if (selectedLanguage) {
        setLanguage(selectedLanguage);
    }
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsExperiencesOpen(false);
        setIsAboutOpen(false);
        setIsLangOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const handleClick = (item, lang) => {
    setLanguage(lang);
    setMenuItem(item);
    localStorage.setItem('selectedLanguage', lang);

    if(item === 12) {
      localStorage.setItem('selectedChallenge', '0');
    }

    setIsExperiencesOpen(false);
    setIsAboutOpen(false);
    setIsLangOpen(false);
    onHeaderClick(item, lang);
  };

  const handleClickMobile = (item, lang) => {
    handleClick(item, lang);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsExperiencesOpen(false);
    setIsAboutOpen(false);
    setIsLangOpen(false);
  };

  const homePath = language === 'pt' ? '/inicio' : '/homepage';
  const aboutPath = language === 'pt' ? '/quemsomos' : '/aboutus';
  const bookingsPath = language === 'pt' ? '/reservas' : '/bookings';
  const vouchersPath = language === 'pt' ? '/vouchers' : '/voucher';
  const contactsPath = language === 'pt' ? '/contactos' : '/contacts';
  const termosPath = language === 'pt' ? '/termos' : '/terms';
  const politicasPath = language === 'pt' ? '/politicas' : '/politics';
  const gamesPath = language === 'pt' ? '/desafios' : '/challenges';
  const despedidasPath = language === 'pt' ? '/despedidas-solteiro' : '/bachelorette-party';
  const teamBuildingsPath = language === 'pt' ? '/team-buildings' : '/team-building';
  const aniversariosPath = language === 'pt' ? '/aniversarios' : '/birthday-parties';
  const loretoChallengePath = language === 'pt' ? '/loreto-challenge' : '/loretochallenge';

  const copy = language === 'pt'
    ? {
        home: 'INÍCIO',
        challenges: 'DESAFIOS',
        experiences: 'EXPERIÊNCIAS',
        about: 'SOBRE',
        aboutus: 'SOBRE NÓS',
        vouchers: 'VOUCHERS',
        contacts: 'CONTACTOS',
        book: 'RESERVAR AGORA',
        aniversarios: 'ANIVERSÁRIOS',
        despedidas: 'DESPEDIDAS DE SOLTEIRO',
        teamBuildings: 'TEAM BUILDINGS',
        loretoChallenge: 'LORETO CHALLENGE',
        termos: 'TERMOS E CONDIÇÕES',
        politicas: 'POLÍTICAS DE PRIVACIDADE'
      }
    : {
        home: 'HOME',
        challenges: 'CHALLENGES',
        experiences: 'EXPERIENCES',
        about: 'ABOUT',
        aboutus: 'ABOUT US',
        vouchers: 'VOUCHERS',
        contacts: 'CONTACTS',
        book: 'BOOK NOW',
        aniversarios: 'BIRTHDAY PARTIES',
        despedidas: 'BACHELORETTE PARTIES',
        teamBuildings: 'TEAM BUILDINGS',
        loretoChallenge: 'LORETO CHALLENGE',
        termos: 'TERMS AND CONDITIONS',
        politicas: 'PRIVACY POLICIES'
      };

  return (
    <header ref={headerRef}>
      <div className="header-back">
        <div className="er-navInner">
          <div className="iconMenu-div">
            <button className="menu-button" type="button" onClick={toggleMenu} aria-label="Menu">&#9776;</button>
          </div>

          <div className="logoMenu-div">
            <Link to={homePath} className="er-navLogoLink" onClick={() => handleClick(2, language)}>
              <img src={logobrilhopequeno} className='logo' alt="Escape Room Bragança"/>
            </Link>
          </div>

          <nav className="menuDiv" aria-label="Main">
            <Link
              to={homePath}
              className={`menuOptions ${menuItemOpen === 1 ? 'menuOptions-selected' : ''}`}
              onClick={() => handleClick(1, language)}
            >
              {copy.home}
            </Link>

            <Link
              to={language === 'pt' ? '/desafios#desafios' : '/challenges#challenges'}
              className="menuOptions"
              onClick={() => handleClick(2, language)}
            >
              {copy.challenges}
            </Link>

            <div className={`er-navDropdown ${isExperiencesOpen ? 'is-open' : ''}`}>
              <button
                type="button"
                className={`menuOptions er-navDropdownTrigger ${menuItemOpen === 3 || menuItemOpen === 4 || menuItemOpen === 5 || menuItemOpen === 6 ? 'menuOptions-selected' : ''}`}
                onClick={() => {
                  setIsExperiencesOpen((open) => !open);
                  setIsAboutOpen(false);
                  setIsLangOpen(false);
                }}
                aria-expanded={isExperiencesOpen}
              >
                {copy.experiences}
                <FontAwesomeIcon icon={faChevronDown} className="er-navChevron" />
              </button>
              {isExperiencesOpen && (
                <div className="er-navDropdownMenu" role="menu">
                  <Link
                    to={aniversariosPath}
                    className="er-navDropdownItem"
                    role="menuitem"
                    onClick={() => handleClick(3, language)}
                  >
                    {copy.aniversarios}
                  </Link>
                  <Link
                    to={despedidasPath}
                    className="er-navDropdownItem"
                    role="menuitem"
                    onClick={() => handleClick(4, language)}
                  >
                    {copy.despedidas}
                  </Link>
                  <Link
                    to={teamBuildingsPath}
                    className="er-navDropdownItem"
                    role="menuitem"
                    onClick={() => handleClick(5, language)}
                  >
                    {copy.teamBuildings}
                  </Link>
                  <Link
                    to={loretoChallengePath}
                    className="er-navDropdownItem"
                    role="menuitem"
                    onClick={() => handleClick(6, language)}
                  >
                    {copy.loretoChallenge}
                  </Link>
                </div>
              )}
            </div>

            <div className={`er-navDropdown ${isAboutOpen ? 'is-open' : ''}`}>
              <button
                type="button"
                className={`menuOptions er-navDropdownTrigger ${menuItemOpen === 7 || menuItemOpen === 8 || menuItemOpen === 9 ? 'menuOptions-selected' : ''}`}
                onClick={() => {
                  setIsAboutOpen((open) => !open);
                  setIsExperiencesOpen(false);
                  setIsLangOpen(false);
                }}
                aria-expanded={isAboutOpen}
              >
                {copy.about}
                <FontAwesomeIcon icon={faChevronDown} className="er-navChevron" />
              </button>
              {isAboutOpen && (
                <div className="er-navDropdownMenu" role="menu">
                  <Link
                    to={aboutPath}
                    className="er-navDropdownItem"
                    role="menuitem"
                    onClick={() => handleClick(7, language)}
                  >
                    {copy.aboutus}
                  </Link>
                  <Link
                    to={termosPath}
                    className="er-navDropdownItem"
                    role="menuitem"
                    onClick={() => handleClick(8, language)}
                  >
                    {copy.termos}
                  </Link>
                  <Link
                    to={politicasPath}
                    className="er-navDropdownItem"
                    role="menuitem"
                    onClick={() => handleClick(9, language)}
                  >
                    {copy.politicas}
                  </Link>
                </div>
              )}
            </div>

            <Link
              to={vouchersPath}
              className={`menuOptions ${menuItemOpen === 10 ? 'menuOptions-selected' : ''}`}
              onClick={() => handleClick(10, language)}
            >
              {copy.vouchers}
            </Link>

            <Link
              to={contactsPath}
              className={`menuOptions ${menuItemOpen === 11 ? 'menuOptions-selected' : ''}`}
              onClick={() => handleClick(11, language)}
            >
              {copy.contacts}
            </Link>
          </nav>

          <div className="er-navActions">
            <div className="er-navDivider" aria-hidden="true" />

            <Link
              to={bookingsPath}
              className="er-navCta"
              onClick={() => handleClick(12, language)}
            >
              <FontAwesomeIcon icon={faCalendarDays} className="er-navCtaIcon" />
              <span>{copy.book}</span>
            </Link>

            <div className={`er-langSwitcher ${isLangOpen ? 'is-open' : ''}`}>
              <button
                type="button"
                className="er-langButton"
                onClick={() => {
                  setIsLangOpen((open) => !open);
                  setIsExperiencesOpen(false);
                  setIsAboutOpen(false);
                }}
                aria-expanded={isLangOpen}
                aria-label="Language"
              >
                <img
                  src={language === 'pt' ? logoPT : logoEN}
                  className="icon"
                  alt=""
                />
                <span className="er-langCode">{language.toUpperCase()}</span>
                <FontAwesomeIcon icon={faChevronDown} className="er-navChevron" />
              </button>

              {isLangOpen && (
                <div className="er-langMenu" role="menu">
                  <button
                    type="button"
                    className={`er-langOption ${language === 'pt' ? 'is-active' : ''}`}
                    role="menuitem"
                    onClick={() => handleClick(menuItemOpen, 'pt')}
                  >
                    <img src={logoPT} className="icon" alt="" />
                    <span>PT</span>
                  </button>
                  <button
                    type="button"
                    className={`er-langOption ${language === 'en' ? 'is-active' : ''}`}
                    role="menuitem"
                    onClick={() => handleClick(menuItemOpen, 'en')}
                  >
                    <img src={logoEN} className="icon" alt="" />
                    <span>EN</span>
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="icon-div-mobile">
            {language === 'pt' ? (
              <img src={logoPT} className="icon" onClick={() => handleClick(menuItemOpen, 'en')} alt="EN"/>
            ) : (
              <img src={logoEN} className="icon" onClick={() => handleClick(menuItemOpen, 'pt')} alt="PT"/>
            )}
          </div>
        </div>

        {isMenuOpen && (
          <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
            <Link
              to={homePath}
              className={`mobile-menuOptions ${menuItemOpen === 1 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(1, language)}
            >
              {copy.home}
            </Link>

            <Link
              to={language === 'pt' ? '/desafios#desafios' : '/challenges#challenges'}
              className={`mobile-menuOptions ${menuItemOpen === 2 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(2, language)}
            >
              {copy.challenges}
            </Link>

            <p className="mobile-menuGroupLabel">{copy.experiences}</p>
            <Link
              to={aniversariosPath}
              className={`mobile-menuOptions mobile-menuOptions-sub ${menuItemOpen === 3 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(3, language)}
            >
              {copy.aniversarios}
            </Link>
            <Link
              to={despedidasPath}
              className={`mobile-menuOptions mobile-menuOptions-sub ${menuItemOpen === 4 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(4, language)}
            >
              {copy.despedidas}
            </Link>
            <Link
              to={teamBuildingsPath}
              className={`mobile-menuOptions mobile-menuOptions-sub ${menuItemOpen === 5 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(5, language)}
            >
              {copy.teamBuildings}
            </Link>
            <Link
              to={loretoChallengePath}
              className={`mobile-menuOptions mobile-menuOptions-sub ${menuItemOpen === 6 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(6, language)}
            >
              {copy.loretoChallenge}
            </Link>

            <p className="mobile-menuGroupLabel">{copy.about}</p>
            <Link
              to={aboutPath}
              className={`mobile-menuOptions mobile-menuOptions-sub ${menuItemOpen === 7 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(7, language)}
            >
              {copy.aboutus}
            </Link>
            <Link
              to={termosPath}
              className={`mobile-menuOptions mobile-menuOptions-sub ${menuItemOpen === 8 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(8, language)}
            >
              {copy.termos}
            </Link>
            <Link
              to={politicasPath}
              className={`mobile-menuOptions mobile-menuOptions-sub ${menuItemOpen === 9 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(9, language)}
            >
              {copy.politicas}
            </Link>

            <Link
              to={vouchersPath}
              className={`mobile-menuOptions ${menuItemOpen === 10 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(10, language)}
            >
              {copy.vouchers}
            </Link>

            <Link
              to={contactsPath}
              className={`mobile-menuOptions ${menuItemOpen === 11 ? 'mobile-menuOptions-selected' : ''}`}
              onClick={() => handleClickMobile(11, language)}
            >
              {copy.contacts}
            </Link>

            <Link
              to={bookingsPath}
              className="er-navCta er-navCta-mobile"
              onClick={() => handleClickMobile(12, language)}
            >
              <FontAwesomeIcon icon={faCalendarDays} className="er-navCtaIcon" />
              <span>{copy.book}</span>
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default HeaderApp;
